/** @jsx jsx */
import { Box, Flex, Grid, Paragraph } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { LifecycleAction } from "@/data/lifecycle";

import { LifecycleCard } from "./LifecycleCard";

interface LifecycleListProps {
  actions: LifecycleAction[];
}

export const LifecycleList: FC<LifecycleListProps> = ({ actions, children }) => {
  const { t } = useTranslation("session");

  return (
    <Flex flexDirection="column" gap={["xxs", null, null, "xs"]}>
      <Box px="md" sx={{ display: ["none", null, null, "block"] }}>
        <Grid columns="1fr 1fr 1fr">
          <Paragraph color="n700">{t("LIFECYCLE.ACTION")}</Paragraph>
          <Paragraph color="n700">{t("LIFECYCLE.WHO")}</Paragraph>
          <Flex justifyContent="flex-end">
            <Paragraph color="n700">{t("LIFECYCLE.DATE")}</Paragraph>
          </Flex>
        </Grid>
      </Box>

      {actions.map((action, index) => (
        <LifecycleCard key={index} action={action} />
      ))}

      {children}
    </Flex>
  );
};
